export default __webpack_public_path__ + "static/media/17.b046a9b1.jpg";